export default __webpack_public_path__ + "static/media/forward.f37c5cd6.svg";